var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rating',{attrs:{"value":_vm.value,"length":_vm.length,"half-increments":_vm.halfIncrements,"readonly":"","dense":"","color":_vm.color,"background-color":_vm.backgroundColor}})}
var staticRenderFns = []

export { render, staticRenderFns }